import { useEffect, useState } from "react";
import { Shield, KeyRound } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function Settings() {
  const { user } = useAuth();
  const [health, setHealth] = useState(null);

  useEffect(() => {
    api.get("/health").then((r) => setHealth(r.data));
  }, []);

  return (
    <div className="space-y-6 max-w-2xl">
      <div>
        <div className="text-xs uppercase tracking-[0.25em] text-neutral-500 font-mono">
          Account
        </div>
        <h1 className="font-display text-4xl font-semibold tracking-tight mt-2">
          Settings
        </h1>
      </div>
      <div className="border border-[#1a1a1a] bg-[#0d0d0d] rounded-lg p-6 space-y-3">
        <div className="text-[10px] uppercase tracking-[0.25em] text-neutral-500 font-mono">
          Profile
        </div>
        <div className="flex items-center gap-3">
          {user?.picture ? (
            <img src={user.picture} alt="" className="w-10 h-10 rounded-full" />
          ) : (
            <div className="w-10 h-10 rounded-full bg-[#1a1a1a]" />
          )}
          <div className="flex-1">
            <div className="text-sm flex items-center gap-2">
              {user?.name}
              {user?.is_admin && (
                <span
                  className="text-[10px] font-mono uppercase tracking-[0.18em] inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full border border-amber-400/30 text-amber-400 bg-amber-400/10"
                  data-testid="admin-badge"
                >
                  <Shield className="w-3 h-3" strokeWidth={1.8} />
                  Admin
                </span>
              )}
            </div>
            <div className="text-xs text-neutral-500 font-mono">{user?.email}</div>
          </div>
        </div>
        <div className="flex items-center gap-2 pt-2">
          <KeyRound className="w-3.5 h-3.5 text-neutral-500" strokeWidth={1.5} />
          <span className="text-xs text-neutral-500 font-mono uppercase tracking-[0.18em]">
            Sign-in method:
          </span>
          <span className="text-xs text-neutral-300 font-mono">
            {user?.auth_provider || "google"}
          </span>
        </div>
      </div>
      <div className="border border-[#1a1a1a] bg-[#0d0d0d] rounded-lg p-6 space-y-3">
        <div className="text-[10px] uppercase tracking-[0.25em] text-neutral-500 font-mono">
          System
        </div>
        <div className="text-sm">
          <div className="flex items-center justify-between py-1.5">
            <span className="text-neutral-400">Gmail OAuth</span>
            <span
              data-testid="gmail-config-status"
              className={`font-mono ${
                health?.gmail_configured ? "text-emerald-400" : "text-amber-400"
              }`}
            >
              {health?.gmail_configured ? "configured" : "needs credentials"}
            </span>
          </div>
          <div className="flex items-center justify-between py-1.5">
            <span className="text-neutral-400">SMTP / IMAP</span>
            <span className="font-mono text-emerald-400">enabled</span>
          </div>
          <div className="flex items-center justify-between py-1.5">
            <span className="text-neutral-400">AI provider</span>
            <span className="font-mono text-neutral-300">claude-sonnet-4.5</span>
          </div>
        </div>
        {!health?.gmail_configured && (
          <p className="text-xs text-amber-400/80 leading-relaxed mt-2">
            Gmail OAuth not yet configured. You can still connect Gmail mailboxes
            via{" "}
            <span className="font-mono">Inboxes → Connect mailbox → Gmail (App
            Password)</span>
            . That path requires zero Google Cloud setup - just a 16-char App
            Password.
          </p>
        )}
      </div>
    </div>
  );
}
